import style from './articles-not-found-block.module.scss'

const ArticlesNotFound = () => {
    return (
        <div className={style.searchText}>
            Unfortunately, no articles were found matching your search criteria.
        </div>
    )
}

export default ArticlesNotFound;
